import React from "react";
import FixedIncomeInstrument from "./FixedIncomeInstrument";
import { classNameForValidationErrors } from "../../common/components/componentUtils";
import { tdStyles } from "../../common/styles";
import Direction from "./Direction";
import RemoveButton from "./RemoveButton";
import Price from "./Price";
import Derivative from "./Derivative";
import {RECOMMENDABLE_TYPE} from "../constants";

const descriptionPlaceholderForRecommendableType = {
    [RECOMMENDABLE_TYPE.BOND]: "(only if Derivative)",
    [RECOMMENDABLE_TYPE.SOVEREIGNTY]: "Tenor etc.",
    [RECOMMENDABLE_TYPE.ISSUER]: "Tenor etc.",
    [RECOMMENDABLE_TYPE.INTEREST_RATE_FUTURE]: "Expiry etc."
};

const FixedIncomeRecommendationLeg = (props) => (
    <tr>
        <td style={tdStyles}>
            <Direction {...props.direction} />
        </td>
        <td style={tdStyles}>
             <FixedIncomeInstrument {...props.instrument}
                              className={ classNameForValidationErrors(props.instrument) }/>
        </td>
        <td style={tdStyles}>
            <Derivative derivativeDescription={props.derivativeDescription}
                        placeholder={ descriptionPlaceholderForRecommendableType[props.instrument.value.recommendableType] }
                        className={ classNameForValidationErrors(props.derivativeDescription) }/>
        </td>
        <td style={tdStyles}>
            <Price {...props.suppliedPrice}
                   disabled={ isIssuerOrSovereignty(props.instrument.value.recommendableType) }
                   className={`x-market-price ${classNameForValidationErrors(props.suppliedPrice)}`} />
        </td>
        <td style={tdStyles}>
            <Price {...props.targetPrice}
                   disabled={ isIssuerOrSovereignty(props.instrument.value.recommendableType) }
                   className="x-target-price"/>
        </td>
        <td>
            <RemoveButton onClick={props.onRemoveLeg} />
        </td>
    </tr>
);

function isIssuerOrSovereignty(recommendableType) {
    return [ RECOMMENDABLE_TYPE.ISSUER, RECOMMENDABLE_TYPE.SOVEREIGNTY ].includes(recommendableType);
}

export default FixedIncomeRecommendationLeg;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/FixedIncomeRecommendationLeg.js
 **/